import { toast } from 'sonner';

export const API_CP = (annee) => `/conseil-perfectionnement/${annee}`;
export const STATUTS_CP = { preparation: 'En préparation', convoque: 'Convocations envoyées', tenu: 'Séance tenue', cloture: 'Compte rendu validé' };
export const MODES_CP = { presentiel: 'Présentiel', visio: 'Visio', hybride: 'Présentiel + visio' };

export const nomComplet = (p) => `${p?.prenom || ''} ${p?.nom || ''}`.trim();
export const qualiteOrg = (p) => [p.qualite, p.organisation].filter(Boolean).join(' – ');
export const dateFR = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T00:00` : iso).toLocaleDateString('fr-FR') : '');
export const erreur = (e, def) => toast.error(e.response?.data?.detail || def);

const ALIAS_THEMES = { conventions: 'partenariats', investissements: 'partenariats', qualite: 'resultats' };
const canon = (t) => ALIAS_THEMES[t] || t;
export const themeDe = (p) => p.aide_cle || canon(p.theme || '');
// Point déjà couvert : même intitulé ou même thème (un point « partenariats » couvre conventions et investissements)
export const dejaPresent = (points, { titre, cle }) => points.some((p) => p.titre === titre || (!!cle && (p.theme === cle || themeDe(p) === cle || p.theme === canon(cle))));
export const nouveauPoint = (titre = '', details = '', theme = '') => ({ titre, details, theme, presente: '', propositions: '', avis: '', decisions: [] });

export const Carte = ({ children, className = '', ...rest }) => (
  <section className={`rounded-2xl border border-slate-200 bg-white p-5 sm:p-7 shadow-sm ${className}`} {...rest}>{children}</section>
);

export const TitreCarte = ({ Icone, titre, sousTitre, children }) => (
  <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
    <div className="flex items-start gap-3">
      <div className="rounded-xl bg-[#8DC63F]/15 p-2.5"><Icone className="h-5 w-5 text-[#6FA22E]" /></div>
      <div>
        <h2 className="text-base md:text-lg font-semibold text-[#0F172A]">{titre}</h2>
        {sousTitre && <p className="mt-0.5 max-w-2xl text-sm text-slate-500">{sousTitre}</p>}
      </div>
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Champ = ({ label, children, className = '' }) => (
  <div className={`space-y-1.5 ${className}`}>
    <span className="block text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
    {children}
  </div>
);
